export const DEFAULT_LOGO_URL = 'https://media.appcharge.com/defaults/default-store-logo.svg';
